import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  sections: {
    state: {
      title: 'Estado',
      fields: {
        delivery_visible: {
          label: 'Entrega visível',
        },
        has_delivery: {
          label: 'Entrega',
        },
        delivery_enabled: {
          label: 'Entrega ativa',
        },
      },
    },
    delivery_mode: {
      title: 'Modo de entrega',
      fields: {
        delivery_mode: {
          options: {
            [DeliveryMode.Internal]: 'Frota de estafetas do restaurante',
            [DeliveryMode.External]: 'Frota de estafetas externos ({{providers}})',
          },
        },
        external_delivery_pickup_note: {
          label: 'Nota de recolha para o estafeta',
          placeholder: 'Informação extra de recolha para o estafeta (ex.: como encontrar a entrada, etc.)',
        },
        instant_print_enabled: {
          label: 'Imprimir talão sem aguardar o estafeta',
        },
        provider_not_connected: {
          wolt_drive: 'Ainda não está ligado: este restaurante não tem um ID de estabelecimento Wolt válido.',
          connects_on_external:
            '{{provider}} é ligado quando o modo de entrega é definido para motoristas externos e guardado.',
          not_connected_yet:
            '{{provider}} ainda não está ligado para este restaurante. Se isto não mudar, contacte o suporte.',
        },
      },
    },
    scheduled_orders: {
      title: 'Encomendas agendadas',
      fields: {
        has_scheduled_orders: {
          label: 'Permite que os clientes encomendem com antecedência para horas específicas?',
        },
        min_schedule_ahead_time_delivery: {
          label: 'Tempo mínimo (minutos) de antecedência para agendar encomendas de <strong>entrega</strong>',
          placeholder: '60',
          validation_name: 'Tempo mínimo de agendamento de entrega',
          external_hint: 'Com entrega externa, deve ser pelo menos {{minutes}} minutos (2 horas). ',
        },
        last_order_gap_delivery: {
          label: 'Última hora para encomendar <strong>entrega</strong> (minutos antes do fecho)',
          option: '{{value}} min',
        },
      },
    },
    delivery_info: {
      title: 'Informações de entrega',
      fields: {
        average_order_delivery_time_min: {
          label: 'Tempo de entrega',
          placeholder: 'Tempo em minutos',
        },
        average_order_delivery_time_max: {
          label: 'até',
          placeholder: 'Opcional',
        },
      },
    },
    delivery_zones: {
      title: 'Zonas de entrega',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    at_least_one_order_method_required:
      'É necessário ter pelo menos 1 método de encomenda (agendado ou imediato) ativo. Não pode desativar ambos.',
  },
};
